import React from "react";
import {Outlet } from "react-router-dom";
import "../App.css";
import '../Admin.css'

const AuthLayout = (props)=>{

    return (
        <div className="authWrapper">
            <Outlet/>
        </div>
    )
}

export default AuthLayout;